module.exports = __webpack_public_path__ + "static/media/logo.8b4c195f.png";